import { createFileRoute, redirect } from "@tanstack/react-router"

import { query } from "@/api/query"
import { MY_SPACE } from "@/constants/spaces"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/courses/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { allowMinor: true })

    const spaces = await context.queryClient.query({ ...query.space.list, staleTime: "static" })
    const space = spaces.find(sp => sp.id === context.spaceStorage.getSpace()) || MY_SPACE

    // If the space is not an enterprise space, redirect to root
    if (space.space === "pro") {
      redirect({
        to: "/",
        throw: true
      })
    }
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()
    queryClient.query({ ...query.space.kits(space), staleTime: "static" })
    queryClient.query({ ...query.space.kits(MY_SPACE.id), staleTime: "static" })
  },
  shouldReload: () => true,
  head: () => ({
    meta: [
      {
        title: "Courses | Arduino Cloud"
      }
    ]
  })
})
